export default __webpack_public_path__ + "static/media/discount-code.41a6a238.svg";